// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserInfoInputs_wrapper__26Np0","loginNameInput":"UserInfoInputs_loginNameInput__3eMd5","domainInput":"UserInfoInputs_domainInput__1-8cm"};